import { ContentDelete } from '@fs/zion-icon'
import { IconButton, useOverlay, DangerButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DeleteGroupMembersDialogOverlay from './DeleteGroupMembersDialogOverlay'
import { showElement } from '../../../util/CssUtil'

export default function DeleteGroupMembersButton({ members, refreshData, single, show }) {
  const overlay = useOverlay()
  const { t } = useTranslation()

  return (
    <span css={show !== undefined && showElement(show)}>
      <DeleteGroupMembersDialogOverlay members={members} refreshData={refreshData} {...overlay} />
      {single ? (
        <IconButton id="Delete Group Member" Icon={ContentDelete} color="red" onClick={overlay.handleClick} />
      ) : (
        <DangerButton id="Delete Group Members" Icon={ContentDelete} onClick={overlay.handleClick}>
          {t('action.delete', 'Delete')}
        </DangerButton>
      )}
    </span>
  )
}
